/**
     * Helper function to read sequences of coded elements, like:
     * - Channel Source Sequence (003A,0208)
     * - Channel Sensitivity Units Sequence (003A,0211)
     */
export const readCodeSequence = (codeSequence) => {
  const code = {};
  if (codeSequence !== undefined) {
    if (codeSequence.items.length > 0) {
      const codeDataset = codeSequence.items[0].dataSet;
      code.codeValue = codeDataset.string('x00080100'); // VR = SH
      code.codingSchemeDesignator = codeDataset.string('x00080102'); // VR = SH
      code.codingSchemeVersion = codeDataset.string('x00080103'); // VR = SH
      code.codeMeaning = codeDataset.string('x00080104'); // VR = LO
    }
  }
  return code;
};
